import React from "react";
import UnexpectedErrorLogo2 from "../../icons/UnexpectedError2.svg";
import VectorTopRight from "../../icons/VectorTopRight.svg";
import VectorBottomLeft from "../../icons/VectorBottomLeft.svg";
import MMTCLOGO from "../../icons/MMTCLOGO.svg";
import { Button } from "../ui/button";

export const UnexpectedErrorScreen = () => {
  const handleRetry = () => {
    window.location.reload();
  };

  return (
    <div className="flex w-full h-screen justify-center items-center bg-white relative overflow-hidden">
      {/* Background Vectors */}
      <div className="absolute top-0 right-0 z-0 pointer-events-none">
        <VectorTopRight />
      </div>
      <div className="absolute bottom-0 left-0 z-0 pointer-events-none">
        <VectorBottomLeft />
      </div>

      <div className="absolute top-[90px] w-full flex justify-center z-[1]">
        <MMTCLOGO />
      </div>

      <div className="w-[565px] p-10 flex flex-col items-center gap-[10px] rounded-[10px] bg-transparent z-[1] sm:w-[90%] sm:p-5">
        <div className="flex justify-center items-center">
          <UnexpectedErrorLogo2 style={{ width: "173px", height: "153px" }} />
        </div>
        <div className="font-['Open_Sans',_sans-serif] font-bold text-[20px] text-black text-center leading-[1.36]">
          An unexpected error has occurred
        </div>
        <div className="font-['Open_Sans',_sans-serif] font-normal text-[16px] text-[#3C3C3C] text-center leading-[1.625] max-w-[561px]">
          There was an issue processing your request. Please try again, and 
          if the problem continues, contact your Loan Officer for assistance.
        </div>
        <Button
          variant="default"
          size="default"
          className="bg-secondary-2 text-white hover:shadow-md"
          onClick={handleRetry}
        >
          Retry
        </Button>
      </div>
    </div>
  );
};
